export const RATE_TYPES = {
  USER: 'userRates',
  ROLE: 'roleRates',
  PROJECT: 'projectRate'
};
